import React from "react";

import { IIconType } from "components/shared/icon_types/_prop_interface";

/* tslint:disable:max-line-length */
function MoreVert({ size, color, ...rest }: IIconType) {
  return (
    <svg
      aria-hidden="true"
      className="svg-inline--fa fa-ellipsis-v fa-w-6"
      data-icon="ellipsis-v"
      data-prefix="fas"
      focusable="false"
      height={size}
      width={size}
      role="img"
      viewBox="0 0 192 512"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <path
        fill={color}
        d="M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
      />
    </svg>
  );
}

export default MoreVert;
